<script>
import {supabase} from "./supabaseClient"
import router from 'page'
import UserMenu from "./UserMenu.svelte"

import {user} from "./sessionStore"

import { MaterialApp, Avatar,List,ListItem,Divider, Subheader, Menu, Dialog} from 'svelte-materialify';

function getAppDomain(){
  let appURL = document.location.protocol;
  appURL += '//app.'
  let parts = location.hostname.split('.')
  if(parts[parts.length-1] == 'ai') {
      appURL += parts[parts.length - 2] + '.ai'
  } else if (parts[parts.length-1] == 'localhost'){
    appURL += parts[parts.length - 1]
  }
  return appURL
}

const handleSignOut = async () => {
  let { error } = await supabase.auth.signOut()
  router.redirect('/')
}

</script>
<header>

{#if $user}
  <a href="/" style="display:flex">
    <img src="/images/largeLogo.png" style="align-self:center" alt="MoodFirst Logo" width="234px"/>
  </a>
{:else}
  <a href="https://www.moodfirst.ai/" style="display:flex">
    <img src="/images/largeLogo.png" style="align-self:center" alt="MoodFirst Logo" width="234px"/>
  </a>
{/if}

  {#if $user}
  <div style="margin-left: auto; margin-right: 60px; margin-top: 25px;">

    <UserMenu user={user}   on:SignOut={handleSignOut}/>
    </div>

  <!-- <div style="margin-left: auto; margin-right: 60px; margin-top: 25px;">
    <Menu nudgeX="-160" XoffsetX="true">
    <div slot="activator">
      <Avatar size="36px" class="Xprimary-color" style="background-color:var(--blue); color: white; cursor:pointer">{userInitials}</Avatar>
    </div>
    <List>
      <Subheader>
        <div style="font-size:8p; line-height: 14px; color:var(--blue); font-weight: bold">{$user.email}</div>
        {#if user.plan}
        <div style="font-size:8p; line-height: 14px; color:var(--aqua)">{user.plan} Edition</div>
        {/if}
      </Subheader>
      <Divider style="border-color:#dbdbdb !important"/>
      <ListItem on:click={navMyBoards} style="background-color:white">My Boards</ListItem>
      <ListItem on:click={handleSignOut} style="background-color:white">Sign Out</ListItem>
    </List>
  </Menu>
  </div> -->
  {:else}
  <a href={getAppDomain()} style="margin-left: auto; margin-right: 60px; margin-top: 25px;" class="navLink" >Login</a>
  {/if}
</header>

<style>
header{padding-left:90px; height:50px; line-height: 50px; display: flex; flex-direction: row;background-color: #fafafa; height: 110px}
.navLink {color: var(--blue); font-weight:bold; font-size: 18px}
</style>
